import { CustomvalidationService } from './services/customvalidation.service';
import { MatchPasswordDirective } from './directives/match-password.directive';
import { PasswordRecoveryService } from './services/password-recovery.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginService } from './services/login.service';
import { ChangePasswordService } from './services/change-password.service';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { MaterialModule } from '@ebw-monorepo/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { PasswordRecoveryComponent } from './components/password-recovery/password-recovery.component';
import { PasswordPatternDirective } from './directives/password-pattern.directive';
// import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    // BrowserModule,
    // BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    I18NTranslateModule
  ],
  declarations: [ChangePasswordComponent, PasswordRecoveryComponent, MatchPasswordDirective, PasswordPatternDirective],
  providers: [
    LoginService,
    ChangePasswordService,
    // { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
    PasswordRecoveryService,
    CustomvalidationService
  ],
  exports: [ChangePasswordComponent, PasswordRecoveryComponent, MatchPasswordDirective, PasswordPatternDirective]
})
export class LoginModule {}
